/* eslint-disable */

//main layout elements
import Row from 'element-ui/lib/col.js';
import Col from 'element-ui/lib/row.js';
import 'element-theme-chalk/lib/row.css'
import 'element-theme-chalk/lib/col.css'

//elements
import Card from 'element-ui/lib/card.js';
import 'element-theme-chalk/lib/card.css'
import Message from 'element-ui/lib/message.js';
import 'element-theme-chalk/lib/message.css'


//form elements
import Form from 'element-ui/lib/form.js';
import FormItem from 'element-ui/lib/form-item.js';
import Button from 'element-ui/lib/button.js';
import ButtonGroup from 'element-ui/lib/button-group.js';
import Input from 'element-ui/lib/input.js';

import 'element-theme-chalk/lib/button.css'
import 'element-theme-chalk/lib/button-group.css'
import 'element-theme-chalk/lib/form.css'
import 'element-theme-chalk/lib/form-item.css'
import 'element-theme-chalk/lib/input.css'



//import Icon from 'element-ui/lib/icon.js'
//import 'element-theme-chalk/lib/icon.css'

import Radio from 'element-ui/lib/radio.js';
import RadioGroup from 'element-ui/lib/radio-group.js';
import RadioButton from 'element-ui/lib/radio-button.js';

import 'element-theme-chalk/lib/radio.css'
import 'element-theme-chalk/lib/radio-group.css'
import 'element-theme-chalk/lib/radio-button.css'

import Checkbox from 'element-ui/lib/checkbox.js';
import 'element-theme-chalk/lib/checkbox.css'

const globalComponents = {
  install (Vue) {
    Vue.use(Input);
    Vue.use(Button);
    Vue.use(ButtonGroup);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Card);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(RadioButton);
    Vue.use(Checkbox)
  }
}

export default globalComponents
